<template>

	<a-modal :title="isAdd ? '添加推荐':(type=='listadd'?'添加推荐':'修改' )" :maskClosable="false" :width="640" :visible="visible" :confirmLoading="confirmLoading"
	 :cancelText="'取消'" :okText="'确定'" @ok="addPerson" @cancel="handleCancel">
		<a-form layout="horizontal" :form="form">
			<!-- 推荐课程 -->
			<a-form-item  label="推荐课程" :labelCol="{ lg: { span: 7 } }" :wrapperCol="{ lg: { span: 13 } }">
				<a-select v-if="type=='update'"  @change="handleRecommendlist" show-search
				:disabled="true"
    option-filter-prop="children"
    :filter-option="filterOption" 
	class="form-cell" placeholder="请选择" v-decorator="[
            'name',
					{
					rules: [
						{
						required: true,
						message: '请选择推荐的课程',
						},
					],
					validateTrigger: 'change',
					},
				]" >
					<a-select-option v-for="(item, index) in courseList" :value="index" :key="index">{{ item.courseName }}</a-select-option>
				</a-select>
				
				<a-select v-else  @change="handleRecommendlist" show-search
				:disabled="type == 'add'"
    option-filter-prop="children"
    :filter-option="filterOption" class="form-cell" placeholder="请选择" v-decorator="[
            'courseId',
					{
					rules: [
						{
						required: true,
						message: '请选择推荐的课程',
						},
					],
					validateTrigger: 'change',
					},
				]" >
					<a-select-option v-for="(item, index) in courseList" :value="index" :key="index">{{ item.courseName }}</a-select-option>
				</a-select>
				
		
			</a-form-item>
			<!-- 理由 -->
			<a-form-item label="推荐理由" :labelCol="{ lg: { span: 7 } }" :wrapperCol="{ lg: { span: 13 } }">
				<a-input type="text" placeholder="请输入" @blur="validateIntroBlur" v-decorator="[
            'intro',
            {
              rules: [
                {
					required: true,
					validator: (rule, value, cbfn) => {
						let cnReg = /([\u4e00-\u9fa5]|[\u3000-\u303F]|[\uFF00-\uFF60])/g
						let mat = value.match(cnReg)
						let length
						let cnlength
						let enlength
						if(mat){
							cnlength = mat.length*2
							enlength = value.length - mat.length
						}else{
							cnlength = '0'
							enlength = value.length
						}
						length = cnlength + enlength
						if (!value) {
						cbfn('推荐理由不能为空')
						} else if (length > 20) {
						cbfn('仅支持10个汉字或者20个英文')
						} 
						cbfn()
					}
					}
              ],
              validateTrigger: 'change',
            },
          ]" />
			</a-form-item>


		</a-form>
	</a-modal>
</template>

<script>
	import course from "../../api/course";
	export default {
		name: "personFormModal",
		data() {
			return {
				form: this.$form.createForm(this),
				isAdd: true, //是否是新增person
				personId: -1,
				visible: false,
				updateData: {},
				confirmLoading: false,
				courseId: 0,
				schoolId:0,
				offeringId:0,//课程提供方
				offering:'',
				courseName: '',
				likeNumber: 0,
				intro: '',
				params:"",
				kecheng:'',
				courseList:[],
				type:'',
				
			};
		},
		created() {
			
		},
		methods: {
			
			filterOption(input, option) {
				return (
					option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
				);
				},
			//初始化，显示
			init(type, params) {
				this.getCourseList();
				console.log(params);
				
				this.form = this.$form.createForm(this),
				this.type = type
				let formData = {}
				if(type == "add"){
					this.courseId = params.id;
					this.offeringId = params.offeringId;
					this.courseList.forEach((item,index)=>{
						if(params.id==item.courseId){
							formData.courseId = index
						}
					})
				}else if(type == "update"){
					formData.name = params.courseName,
					this.courseId = params.id
					formData.intro = params.intro		
				}
				console.log('formData',formData);
				
				this.visible = true;
				this.isAdd = type === "add" ? true : false;
				setTimeout(() => {
					this.form.setFieldsValue(formData);
					}, 500);
			},

			//隐藏
			handleCancel() {
				this.visible = false;
				this.$emit("closeForm");
			},
			handleRecommendlist(val){
				console.log(val);
				this.index = val
			},
			//新增推荐
			addPerson(value) {
				this.form.validateFields((err, value) => {
					value.schoolId= this.$store.getters.userInfo.schoolId;
					if(this.type == 'update'){
						
						
						value.id = this.courseId;
						
						this.$delete(value,'name')
						this.$delete(value,'schoolId')
						console.log(value);
						if (!err) {
						course.updateRecommend(value).then((res) => {
							this.$message.success("修改成功");
							Object.assign(this.updateData, value);
							this.handleCancel();
							this.$emit("updateData");
						});
						}
					}else if(this.type == 'add'){
						console.log('chakan');
						
						value.courseId=this.courseId;
						value.offeringId=this.offeringId;
						if (!err) {
						course.Recommendsave(value).then((res) => {
								if(res.msg=="success"){
									this.$message.success("新增成功");
										this.handleCancel();
										this.$emit("addPerson");
										this.getCourseList()
								}else{
									this.$message.success(res.msg);
								}
							});
						}
					}else{
						this.courseList.forEach((item,index)=>{
						if(index==this.index){
							value.offeringId = item.offeringId
							value.courseId = item.courseId
						}
						})
						if (!err) {
						course.Recommendsave(value).then((res) => {
							if(res.msg=="success"){
								this.$message.success("新增成功");
									this.handleCancel();
									this.$emit("addPerson");
									this.getCourseList()
							}else{
								this.$message.success(res.msg);
							}
						});
						}
					}
					//校验通过
					
				});
			},
	//课程列表
			getCourseList(params) {
				console.log('下拉选项中课程列表');
				
				this.loading = true;
				let req = utils.common.copy(params);
				delete req.time;
				course.getselectCourseOffering(req).then((res) => {
					console.log("下拉选项中课程列表", res.data.list);
					this.courseList = res.data.list;
				});
			},
// 修改
			updatePerson(value) {
				
				value.offeringId = this.offeringId
							value.courseId = this.courseId
							console.log(value);
				course.updateRecommend(value).then((res) => {
					this.$message.success("修改成功");
					Object.assign(this.updateData, value);
					this.handleCancel();
				});
			},

			validateCourseBlur(e) {
				this.form.setFields({
					courseName: {
						value: e.target.value
					}
				})
			},
			validateLikeBlur(e) {
				this.form.setFields({
					LikeNumber: {
						value: +e.target.value
					}
				})
			},
			validateIntroBlur(e) {
				this.form.setFields({
					intro: {
						value: e.target.value
					}
				})
			},
		},
	};
</script>
<style lang="scss" scoped>
	@import "src/config/var";

	.cl-inner {
		width: calc(100% - 40px);
		padding: 50px 20px 30px;
		background: white;
		margin: 20px auto;
	}

	.ap-form {
		width: 400px;
	}

	.form-oper {
		text-align: center;

		button {
			margin: 0px 5px;
		}
	}
</style>
